module.exports = __webpack_public_path__ + "static/media/220.20928026.webp";